import { companyActionTypes as ACTION } from '../actionTypes';

const initialState = {
  loading: false,
  error: '',
  CheckBackBtn: false,
  registration: {
    message: '',
    payload: null,
    success: false,
  },
  companies: {
    data: {
      pageNo: 1,
    },
    message: '',
  },
  companiesName: {
    data: {},
    message: '',
  },
  companyDetails: {
    data: {},
    message: '',
  },
  companiesByPagging: {
    data: {},
  },
  companyDeleteResponse: {
    data: null,
    message: '',
  },
};

const CompanyReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.COMPANY_FETCH_REQUEST:
      return { ...state, loading: true, error: '' };
    case ACTION.COMPANY_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        companyDeleteResponse: {
          ...state.companyDeleteResponse,
          message: action.payload.message,
        },
      };
    case ACTION.COMPANY_DELETE_REMOVE_MESSAGE:
      return {
        ...state,
        companyDeleteResponse: {},
      };
    case ACTION.COMPANY_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.COMPANY_REMOVE_ERROR:
      return {
        ...state,
        loading: false,
        error: '',
        registration: {
          ...state.registration,
          message: '',
          success: false,
        },
      };
    case ACTION.COMPANY_SET_DATA:
      return {
        ...state,
        loading: false,
        error: '',
        registration: {
          message: action.payload.message,
          payload: action.payload.payload,
          success: true,
        },
      };

    case ACTION.COMPANY_SET_ERROR:
      return { ...state, loading: false, error: action.payload };
    case ACTION.COMPANY_START_FETCH:
      return {
        ...state,
        loading: true,
      };
    case ACTION.FETCH_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        companyDetails: {
          ...state.companyDetails,
          data: action.payload,
          message: '',
        },
        error: '',
      };
    case ACTION.FETCH_COMPANY_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        companyDetails: {
          data: {},
          message: action.payload,
        },
        error: '',
      };
    case ACTION.FETCH_COMPANIES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        companiesByPagging: {
          data: action.payload,
        },
      };
    case ACTION.GET_ALL_COMPANIES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        companies: {
          data: {
            ...(action.payload || {}),
            rows: [...(state.companies?.data?.rows || []), ...(action.payload?.rows || [])]
          },
        },
      };
    case ACTION.GET_ALL_COMPANIES_RESET:
      return {
        ...state,
        companies: {
          data: { rows: [] }
        }
      }
    case ACTION.FETCH_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        companyDetails: {
          ...state.companyDetails,
          data: action.payload,
          message: '',
        },
        error: '',
      };

    case ACTION.FETCH_COMPANY_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        companyDetails: {
          data: {},
          message: action.payload,
        },
        error: '',
      };
    case ACTION.UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        companyDetails: {
          ...state.companyDetails,
          message: action.payload,
        },
        error: '',
      };
    case ACTION.REMOVE_COMPANY_DETAILS_POPUP:
      return {
        ...state,
        loading: false,
        companyDetails: {
          ...state.companyDetails,
          message: '',
        },
        error: '',
      };
    case ACTION.UPDATE_COMPANY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.GET_COMPANIES_NAME_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        companiesName: {
          ...state.companiesName,
          data: action.payload,
        },
      };
    case ACTION.GET_BACKBTN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        CheckBackBtn: true,
      };
    case ACTION.GET_BACKBTN_FAILURE:
      return {
        ...state,
        loading: false,
        error: '',
        CheckBackBtn: false,
      };
    default:
      return state;
  }
};

export default CompanyReducer;
